import { LogDataLayerSendEvent } from "./log-data-layer-send-event";

export class LogDataLayerSendEventSerializer {

  fromJson(json: any): LogDataLayerSendEvent {
    const log = new LogDataLayerSendEvent();

    if (typeof json.success !== 'undefined') {
      log.success = json.success;
      log.data = this.toJson(json.data);
      return log;
    } else {
      return this.toJson(json);
    }
  }

  toJson(logDataLayerSendEvent: LogDataLayerSendEvent): any {
    if (typeof logDataLayerSendEvent === 'object') {
      return {
        id: logDataLayerSendEvent.id,
        data_layer_objects: logDataLayerSendEvent.data_layer_objects,
        person_id: logDataLayerSendEvent.person_id,
        selective_process_id: logDataLayerSendEvent.selective_process_id,
        stage_id: logDataLayerSendEvent.stage_id,
        last_place_id: logDataLayerSendEvent.last_place_id,
        last_place_type_id: logDataLayerSendEvent.last_place_type_id,
      };
    } else {
      return logDataLayerSendEvent;
    }
  }
}
